// These sources can also be passed to links to what is premium page
export const SUBSCRIPTION_JOURNEY_SOURCES = Object.freeze({
  UNSET: "UNSET",
  SESSION: "SESSION",
  END_SESSION_MODAL: "END_SESSION_MODAL",
  SECTION_HOMEPAGE: "SECTION_HOMEPAGE",
  WRONG_ANSWERS_TRIAL: "WRONG_ANSWERS_TRIAL",
  SMART_LEARNING_SIDEBAR: "SMART_LEARNING_SIDEBAR",
  WHAT_IS_PREMIUM_PARENT: "WHAT_IS_PREMIUM_PARENT",
  WHAT_IS_PREMIUM_TEACHER: "WHAT_IS_PREMIUM_TEACHER",
  WHAT_IS_PREMIUM_STUDENT: "WHAT_IS_PREMIUM_STUDENT",
  CLASSROOM: "CLASSROOM",
  CLASSROOM_RECOMMENDED_SECTION: "CLASSROOM_RECOMMENDED_SECTION",
  SETTINGS: "SETTINGS",
  DASHBOARD: "DASHBOARD",
  PREMIUM_AD: "PREMIUM_AD",
  ADD_COURSE: "ADD_COURSE",
  SECTION_HOMEPAGE_ADD_COURSE: "SECTION_HOMEPAGE_ADD_COURSE",
  COURSE_HOMEPAGE_ADD_COURSE: "COURSE_HOMEPAGE_ADD_COURSE",
  COURSE_ASK_AMELIA_PAGE: "COURSE_ASK_AMELIA_PAGE",
  ANONYMOUS_REDIRECT: "ANONYMOUS_REDIRECT",
  SETTINGS_RENEW_PREMIUM: "SETTINGS_RENEW_PREMIUM",
  RETRY_PAYMENT: "RETRY_PAYMENT",
  DASHBOARD_NAVBAR: "DASHBOARD_NAVBAR",
  STUDENT_ATTENTION_GRABBER: "STUDENT_ATTENTION_GRABBER",
  PARENT_ATTENTION_GRABBER: "PARENT_ATTENTION_GRABBER",
  PARENT_NAVBAR: "PARENT_NAVBAR",
  PARENT_ONBOARDING_GET_TUTORING_CTA: "PARENT_ONBOARDING_GET_TUTORING_CTA",
  PARENT_UPGRADE_BUTTON: "PARENT_UPGRADE_BUTTON",
  PARENT_MONITORING_TABLE: "PARENT_MONITORING_TABLE",
  DASHBOARD_AD: "DASHBOARD_AD",
  REDIRECT_FROM_PREMIUM_JOURNEY: "REDIRECT_FROM_PREMIUM_JOURNEY",
  QUESTIONS_ONLY: "QUESTIONS_ONLY",
  EXAM_QUESTIONS: "EXAM_QUESTIONS",
  CHILD_CONNECTION_INVITE: "CHILD_CONNECTION_INVITE",
  SUBSCRIPTION_EXPIRED: "SUBSCRIPTION_EXPIRED",
  MINI_MOCK_GATING_CREATE_AND_GATE: "MINI_MOCK_GATING_CREATE_AND_GATE",
  EXPLAIN_ANSWER: "EXPLAIN_ANSWER",
  CLASSROOM_NAVBAR: "CLASSROOM_NAVBAR"
});

export const SUBSCRIPTION_JOURNEY_PAGE_NAMES = Object.freeze({
  WHAT_IS_PREMIUM_PAGE: "WHAT_IS_PREMIUM_PAGE",
  PRODUCTS_OVERVIEW: "PRODUCTS_OVERVIEW",
  ADD_GUARANTEE: "ADD_GUARANTEE",
  PAYMENT_DETAILS: "PAYMENT_DETAILS",
  RETRY_PAYMENT: "RETRY_PAYMENT",
  STRONG_AUTHENTICATION: "STRONG_AUTHENTICATION",
  SUBSCRIPTION_EXPIRED: "SUBSCRIPTION_EXPIRED",
  CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
  SUBSCRIPTION_INFO_IOS: "SUBSCRIPTION_INFO_IOS",
  USER_DETAILS: "USER_DETAILS",
  ANON_CREATE_SUBSCRIPTION_SUCCESS: "ANON_CREATE_SUBSCRIPTION_SUCCESS"
});

export type PaymentMethod = "card" | "applePay" | "googlePay";
